export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9469.5a465ed2.jpg";